module.exports = __webpack_public_path__ + "img/Southwest_Quinoa_Bowl_Chicken.bf1c6158.jpg";